import HeaderBar from "../../components/header/header-bar/HeaderBar";
import FooterBar from "../../components/footer/FooterBar";
import ScrollToTop from "../scroll/ScrollToTop";
import CookieConsentBanner from "../../components/cookies/CookieConsentBanner";
import { Outlet } from "react-router-dom";

function RootLayout() {
    return (
        <>
            <ScrollToTop />
            <HeaderBar />
            <Outlet />
            <FooterBar />
            <CookieConsentBanner />
        </>
    )
}

export default RootLayout;